import { connect } from 'react-redux'
import InfoMessage from './info-message'
import { getAssessment } from '../../../../../../stores/assessment/assessment.selectors'

const mapStateToProps = (state, { id }) => {
  const assessmentFile = getAssessment(state, id)
  return {
    student:
      assessmentFile &&
      assessmentFile.student_type &&
      assessmentFile.student_type.account &&
      assessmentFile.student_type.account.full_name,
    worksCount:
      assessmentFile &&
      assessmentFile.works &&
      assessmentFile &&
      assessmentFile.works.length
  }
}

export default connect(
  mapStateToProps,
  null
)(InfoMessage)
